import { render, staticRenderFns } from "./NotificationHomeModal.vue?vue&type=template&id=24dceeb8"
import script from "./NotificationHomeModal.vue?vue&type=script&lang=js"
export * from "./NotificationHomeModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationHomeModal.vue?vue&type=style&index=0&id=24dceeb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports